




































import Vue from 'vue'
import { isIOS } from 'mobile-device-detect'
import Rating from '@components/Rating.vue'
import WrappedLink from '@components/WrappedLink.vue'
import { StoreBannerDetails } from '@/types/app'
export default Vue.extend({
  name: 'StoreBanner',
  components: {
    Rating,
    WrappedLink
  },
  data () {
    const platformConfigs: Record<string, StoreBannerDetails> = {
      ios: {
        name: 'ios',
        link: 'https://apps.apple.com/us/app/myscs/id1410856564'
      },
      android: {
        name: 'android',
        link: 'https://play.google.com/store/apps/details?id=com.bostonscientific.cadence'
      }
    }
    return {
      platform: isIOS ? platformConfigs.ios : platformConfigs.android,
      visible: true
    }
  },
  async mounted () {
    if (isIOS) {
      this.$set(this.platform, 'rating', await this.$store.dispatch('app/GetStoreRating', 1410856564))
    }
  }
})
